import React, { useState, useEffect } from 'react';
import GoogleLoginButton from '@components/reusable/googleLogin';
import { useRouter } from 'next/router';
import { CenteredSpinner } from '@components/reusable/index.spinner';
import { FcGoogle } from 'react-icons/fc';
import axios from '../../utils/api';
import Interests from './interests';
import HandleModal from './index.handle';
import {
  Wrapper,
  Circles,
  Circle,
  CenterContent,
  TextSide,
  Title,
  SubTitle,
  Button,
  ImageSide,
  Div,
} from './index.styles';
import SuggestedFollows from './suggestedusers';
import { useSelector } from 'react-redux';

export default function WelcomePage() {
  const router = useRouter();
  const [showMessage, setShowMessage] = useState(false);
  const userInfo = useSelector((state) => state.auth.userInfo);
  const toggleSettingsSuccess = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    setTimeout(() => {
      setShowMessage(!showMessage);
    }, 200);

    setTimeout(() => {
      setShowMessage(false);
    }, 5000);
  };
  const [showHandle, setShowHandle] = useState(false);

  function googleButton(renderProps) {
    return (
      <Button onClick={() => renderProps.onClick()}>
        <FcGoogle className="icon" size={'25px'} />
        Get started with google
      </Button>
    );
  }

  const processResponse = (response) => {
    if (response) {
      setShowHandle(true);
    }
  };

  const [loading, setLoading] = useState(false);

  const [userIdExists, setUserIdExists] = useState(null);
  const [userId, setUserId] = useState(null);

  const [activeModal, setActiveModal] = useState(0);
  // useEffect fetch id from local storage
  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    localStorage.getItem('userid')
      ? setUserIdExists(true)
      : setUserIdExists(false);
    // eslint-disable-next-line no-unused-expressions
    localStorage.getItem('userid') && setUserId(localStorage.getItem('userid'));
  }, [activeModal]);

  useEffect(() => {
    if (userIdExists) {
      router.push('/');
    }
  }, [userIdExists]);

  const [users, setUsers] = useState(null);

  const sendTags = async (tags) => {
    setLoading(true);
    try {
      const res = await axios.put(`/users/${userId}/tags`, { tags });
      setLoading(false);
      if (res?.data.length > 0) {
        if (res?.data?.usersToFollow.length === 0) {
          router.push('/');
        } else {
          setUsers(res?.data?.usersToFollow);
          setActiveModal(2);
        }
      } else {
        router.push('/');
      }
    } catch (error) {
      setLoading(true);
      console.error(error);
    }
  };

  const modals = [
    <HandleModal
      key={0}
      showSuccess={(handleM, handleBool) =>
        toggleSettingsSuccess(handleM, handleBool)
      }
      isSpinning={(val) => setLoading(val)}
      nextModal={() => {
        router.push('/');
      }}
    />,
    <Interests key={1} goToNext={(val) => sendTags(val)} />,
    <SuggestedFollows key={2} users={users} />,
  ];

  return (
    <Div>
      {showHandle ? (
        loading && !userIdExists ? (
          <CenteredSpinner text={'Please wait... '} />
        ) : (
          modals[activeModal]
        )
      ) : loading || userIdExists ? (
        <CenteredSpinner text={'Please wait....'} />
      ) : !userInfo?._id ? (
        <Wrapper>
          <CenterContent>
            <Circles>
              <Circle />
              <Circle />
              <Circle />
              <Circle />
              <Circle />
              <Circle />
              <Circle />
              <Circle />
              <Circle />
              <Circle />
            </Circles>
            <TextSide>
              <Title>Karent. Community Reimagined.</Title>
              <SubTitle>
                <span>Karent </span> is a social platform for communities. Join
                to interact with other members and share your knowledge,
                experience and ideas.
              </SubTitle>
              <div className="center">
                <GoogleLoginButton
                  showMessage={(p, mes) => toggleSettingsSuccess(p, mes)}
                  renderChildren={googleButton}
                  wasSuccess={(val) => processResponse(val)}
                  loadingData={(val) => setLoading(val)}
                />
              </div>
            </TextSide>
            <div className="overlay" />
          </CenterContent>
          <ImageSide
            src={
              'https://res.cloudinary.com/dpnbddror/image/upload/f_auto/v1639668803/static_images/carol-magalhaes-dSsXm15D9hg-unsplash_1_s51nsx.jpg'
            }
          >
            <div className="image-overlay" />
          </ImageSide>
        </Wrapper>
      ) : null}
    </Div>
  );
}
